import { DeleteOutline, Edit } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import CustomGrid from "../../components/grid/CustomGrid";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useCompany } from "../../components/context/CompanyContext";
import Loading from "../../components/loading/loading";
import "../../global.css";
import { userRequest } from "../../requestMethods";
import { formatTimeDDMMYYY } from "../../util/helper";
import Switch from "@mui/material/Switch";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";

export default function ChargebackList() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getChargeback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getChargeback = async () => {
    try {
      setIsLoading(true);
      const res = await userRequest.get(`0/chargeback`);
      setData(res.data);
    } catch (error) {}
    setIsLoading(false);
  };

  const nav = useNavigate();
  const addRow = () => {
    nav(`../chargeback`);
  };

  const columns = [
    {
      field: "chargebackId",
      headerName: "ID da Chargeback",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "paymentReferenceIdResponse",
      headerName: "Código de referência Pagbank",
      width: 200,
      align: "left",
      headerAlign: "left",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "amount",
      headerName: "Valor",
      width: 200,
      align: "left",
      headerAlign: "left",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "dateChargeback",
      headerName: "Data do Chargeback",
      width: 120,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
      valueFormatter: (value) => {
        if (value === null) {
          return "";
        }
        return `${formatTimeDDMMYYY(value)}`;
      },
      valueGetter: (value) => value && new Date(value),
    },
    {
      field: "company",
      headerName: "Empresa",
      width: 200,
      align: "left",
      headerAlign: "left",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "origin",
      headerName: "Origem",
      width: 200,
      align: "left",
      headerAlign: "left",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "comment",
      headerName: "Comentario",
      width: 200,
      align: "left",
      headerAlign: "left",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "createdAt",
      headerName: "Criada em",
      width: 200,
      align: "left",
      headerClassName: "dataGridMuiHeader",
      valueFormatter: (value) => {
        if (value === null) {
          return "";
        }
        return `${formatTimeDDMMYYY(value)}`;
      },
      valueGetter: (value) => value && new Date(value),
    },
    {
      field: "paymentAt",
      headerName: "Data do Débito",
      width: 120,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
      valueFormatter: (value) => {
        if (value === null) {
          return "";
        }
        return `${formatTimeDDMMYYY(value)}`;
      },
      valueGetter: (value) => value && new Date(value),
    },
    {
      field: "orderRef",
      headerName: "Pedido",
      width: 200,
      align: "left",
      headerAlign: "left",
      headerClassName: "dataGridMuiHeader",
    },
  ];
  return (
    <div className="div_custom_">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="div_custom_UpdateRight">
            <br></br>
            <Button
              className="custom_add_top"
              variant="outlined"
              color="secondary"
              startIcon={<AddIcon />}
              onClick={addRow}
              size="small"
            >
              Adicionar Chargeback
            </Button>
          </div>

          <CustomGrid
            gridId="chargebackList"
            getRowId={(row) => row.chargebackId}
            rows={data}
            columns={columns}
            tableHeight="900px"
          />
        </>
      )}
    </div>
  );
}
